export default __webpack_public_path__ + "static/media/ic-ordered-list.17794e28.svg";